import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tick--white",
  "use": "icon-tick--white-usage",
  "viewBox": "0 0 62.602 53.185",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 62.602 53.185\" id=\"icon-tick--white\">\n<g id=\"icon-tick--white_tick--white\">\n\t<polyline style=\"fill:none;stroke:#FFFFFF;stroke-width:10.4385;stroke-miterlimit:10;\" points=\"58.59,3.339 23.215,45.833 \n\t\t3.34,29.28 \t\" />\n</g>\n<g id=\"icon-tick--white_Layer_1\">\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol